/*Popup*/

function popoverDestroyAll(){
    $(".fpopover").remove();
    return null;
}

function popoverGetContentBlock(obj, g_lang, lang){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    if(obj.nodes[0].type=='areaprice'){
        seciton = obj.nodes[0].id;
    }
    var content = "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li>"+
                        "<span class='ticket-lab'>Section </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul>";
    return content;
}
function popoverGetContentBlockVIP(obj){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    if(obj.nodes[0].type=='areaprice'){
        seciton = obj.nodes[0].id;
    }
    var content = "<div class='vip'><div class='ticket-selected-title gold'>" +
                    "<i class='icon-star'></i>VIP"+
                "</div>"+
                "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span> "+
                        "<span class='ticket-val'>"+section+"</span>"+
                    "</li>"+
                "</ul></div>";
    return content;
}

function popoverGetContentSeatVIP(obj){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    var row = split[1];
    var seat = split[2];
    var content = "<div class='vip'><div class='ticket-selected-title gold'>" +
                    "<i class='icon-star'></i>VIP"+
                "</div><div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span>"+
                        "<span class='ticket-val'>"+section+"</span><span class='fa-slash'> | </span>"+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Row </span>"+
                        "<span class='ticket-val'>"+row+"</span><span class='fa-slash'> | </span> "+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Seat </span> "+
                        "<span class='ticket-val'>"+seat+"</span>"+
                    "</li>"+
                "</ul></div>";
    return content;
}
function popoverGetContentSeat(obj){
    var split = obj.nodes[0].id.split("-");
    var section = split[0].split("_")[1];
    var row = split[1];
    var seat = split[2];
    var content = "<div class='ticket-selected-view'>" +
                    "<div class='ticket-selected-view-img'></div>"+
                "</div>" +
                "<ul class='list-unstyled ticket-selected'>"+
                    "<li style='border-left: none;'>"+
                        "<span class='ticket-lab'>Section </span>"+
                        "<span class='ticket-val'>"+section+"</span><span class='fa-slash'> | </span>"+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Row </span>"+
                        "<span class='ticket-val'>"+row+"</span> <span class='fa-slash'> | </span> "+
                    "</li>"+
                    "<li>"+
                        "<span class='ticket-lab'>Seat </span> "+
                        "<span class='ticket-val'>"+seat+"</span>"+
                    "</li>"+
                "</ul>";
    return content;
}

function popoverMove(popover,obj){
    obj = obj.nodes[0];
    if(popover){
        var w = popover.width();
        var h = popover.height();
        var p = popover[0];
        var bb = p.getBoundingClientRect();
        h = bb.height;
        var offset = viewer.scaling_factor-5;

        var top;
        if(obj.anchor.dom[1] < h){
            top= obj.anchor.dom[1]+17;
        }else{
            top= obj.anchor.dom[1]-(h)-15;
        }

        
        var left;
        if(obj.anchor.dom[0] < bb.width){
            left= obj.anchor.dom[0]+17;
        }else{
            left= obj.anchor.dom[0]-(w);
        }

        popover.css("top",top);
        popover.css("left",left);
    }
    return null;
}

function popoverOpen(obj){

    popoverDestroyAll();
    if(!interf.current){
        return;
    }
    /*Popover OBJ COnf*/
    var template;
    var seatview = viewer.getVisibleNodes("seat").length;
    if( !seatview && obj.nodes[0].type === "section") {
        if($.inArray(obj.nodes[0].id,filtering_typereferenced.vip)!=-1){
            template = popoverGetContentBlockVIP(obj);
        }else{
            template = popoverGetContentBlock(obj);
        }
    } else if(obj.nodes[0].type === "seat"){
        if($.inArray(obj.nodes[0].id.split("-")[0],filtering_typereferenced.vip)!=-1){
            template = popoverGetContentSeatVIP(obj);
        }else{
            template = popoverGetContentSeat(obj);
        }
    }

    if(template){

        var popover = $("<div class='fpopover row'>"+template+"</div>");
        //var popover = $("<div class='fpopover row' >"+template+"</div>");
        $("#main-interface").append(popover);

        popoverMove(popover,obj);
        viewer.getThumbnail(obj.nodes[0].id, venue_id,true).then(function(imgUrl){
            $(".ticket-selected-view-img").html("");
            $(".ticket-selected-view-img").css("background-image", "url("+imgUrl+")");
        }).catch(function(e){
            console.log(e);
        })
    }

    return true;
}